import { Icons } from "@/components/ui/icons"

import { ComponentClassName } from "@/types/utility"
import { cn } from "@/lib/utils"
import { Link } from "@/components/ui/primitives/link"

import { appRoute } from "../routes/app-route"
import { AppSearch } from "../routes/app-route.zod"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/containers/tool-tip"

const OPEN_HELP_BUTTON_CONTENT = "Help"

export function OpenHelpButton({ className }: ComponentClassName) {
  const search = appRoute.useSearch() as AppSearch
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          aria-label={OPEN_HELP_BUTTON_CONTENT}
          id="place"
          size={"icon"}
          variant={"outline"}
          to="/help"
          search={search as any}
          mask={{ to: "/help" }}
          className={cn(
            "relative grid place-items-center h-full w-16",
            "!rounded-none border-r-transparent duration-500 overflow-visible",
            className
          )}
        >
          <Icons.general.helpCircle className="w-4 h-4" />
        </Link>
      </TooltipTrigger>

      <TooltipContent>{OPEN_HELP_BUTTON_CONTENT}</TooltipContent>
    </Tooltip>
  )
}
